import { RouteLink } from '@/lib/router'
import type { Crumb } from '@/seo/BreadcrumbJsonLd'

export function PageCrumbs({ items }: { items: Crumb[] }) {
  return (
    <nav aria-label="Breadcrumb" className="mb-8 text-xs uppercase tracking-[0.15em] text-muted-foreground">
      <ol className="flex flex-wrap items-center gap-2">
        {items.map((item, index) => (
          <li key={item.path} className="flex items-center gap-2">
            {index > 0 && <span aria-hidden>/</span>}
            {index === items.length - 1 ? (
              <span className="text-foreground">{item.name}</span>
            ) : (
              <RouteLink to={item.path} className="hover:text-accent">
                {item.name}
              </RouteLink>
            )}
          </li>
        ))}
      </ol>
    </nav>
  )
}
